import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { DriverEntity } from "./driver-entity";
import { Repository } from "typeorm";
import {
  CommonResponseModel,
  DriverReq,
  DriverStatus,
  GlobalResponseObject,
  RoleEnum,
  VehicleStatus,
  roleReq,
} from "@project-management-system/shared-models";
import { DriverDto } from "./driver.dto";
// import dayjs = require("dayjs");
import { DriverId } from "./driver-id";
import moment = require("moment");

@Injectable()
export class DriverService {
  constructor(
    @InjectRepository(DriverEntity)
    private driverRepo: Repository<DriverEntity>
  ) {}

  async createDriver(
    req: DriverReq,
    isUpdate: boolean
  ): Promise<CommonResponseModel> {
    try {
      if(!isUpdate){
        // console.log(req,'requesttttt')
        const duplicate = await this.driverRepo.find({where:{name:req.name,phoneNumber:req.phoneNumber}})
        console.log(duplicate,'duplicateeee')
        if(duplicate.length >0){
          return new CommonResponseModel(false,0,'Driver Name And Phone Number Combination already exists')
        }
      }
      
      const entity = new DriverEntity();
      console.log(req, "reqtey");
      entity.id = req.id;
      entity.name = req.name;
      entity.lastName = req.lastName;
      entity.dateOfBirth = req.dateOfBirth;
      entity.profileImage = req?.profileImage?.file?.name?req?.profileImage?.file?.name:'';
      entity.profileImagePath = req.profileImagePath;
      entity.email = req.email;
      entity.address = req.address;
      entity.state = req.state;
      entity.city = req.city;
      entity.userType = req.userType;
      entity.licenceNumber = req.licenceNumber;
      entity.licenceClass = req.licenceClass;
      entity.licenceState = req.licenceState;
      entity.createdUser = req.userName;
      entity.vendorId = req.vendorId;
      entity.driverType = req.driverType;
      entity.licenceExpirydate=req.licenceExpirydate?moment(req.licenceExpirydate).format('YYYY-MM-DD'):undefined
      console.log(entity,'entityyyyyy')
      entity.status =
        req.userName === "admin" ? RoleEnum.ADMIN : RoleEnum.VENDOR;
      entity.driverStatus = DriverStatus.NOTOCCUPIED;
      if (isUpdate) {
        if (req.phoneNumber.length === 10) {
          entity.id = req.id;
          entity.phoneNumber = "91" + req.phoneNumber;
          entity.updatedUser = req.updatedUser;
        } else {
          entity.id = req.id;
          entity.phoneNumber = req.phoneNumber;
          entity.updatedUser = req.updatedUser;
        }
      } else {
        entity.phoneNumber = "91" + req.phoneNumber;
        entity.createdUser = req.createdUser;
      }
      const save = await this.driverRepo.save(entity);
      if (save) {
        return new CommonResponseModel(
          true,
          0,
          isUpdate
            ? "Driver Updated Successfully"
            : "Driver Created Successfully"
        );
      } else {
        return new CommonResponseModel(false, 0, "Error Occured");
      }
    } catch (err) {
      throw err;
    }
  }

  async getActiveDriver(): Promise<CommonResponseModel> {
    const data = await this.driverRepo.find({ where: { isActive: true } });
    if (data) {
      return new CommonResponseModel(true, 1, "Data Retrived", data);
    } else {
      return new CommonResponseModel(false, 0, "Data Retrived");
    }
  }

  async getAllDriver(req?: roleReq): Promise<CommonResponseModel> {
    let query = `
       SELECT d.id, d.name AS NAME,
      d.last_name AS lastName, d.date_of_birth AS dateOfBirth, 
      d.profile_image AS profileImage, d.email, d.phone_number AS phoneNumber,
       d.address, d.state, d.city, d.user_type AS userType, 
       d.licence_number AS licenceNumber, d.licence_class AS licenceClass,
        d.licence_state AS licenceState, d.status, d.driver_status AS driverStatus, 
        d.is_active AS isActive, d.version_flag AS versionFlag,d.driver_type,d.vendor_code AS externalRefNo
      FROM driver d `;
    const result = await this.driverRepo.query(query);
  
    if (result) {
      return new CommonResponseModel(true, 1, "Data Retrieved", result);
    } else {
      return new CommonResponseModel(false, 0, "Data Retrieved");
    }
  }
  async activateOrDeactivateDriver(
    req: DriverDto
  ): Promise<CommonResponseModel> {
    const record = await this.driverRepo.findOne({ where: { id: req.id } });
    await this.driverRepo.update(
      { id: req.id },
      { isActive: !record.isActive }
    );
    const internalMessage: string = !record.isActive
      ? "Activated Sucessfully"
      : "Deactivated Successfully";
    return new CommonResponseModel(true, 6876, internalMessage);
  }

  async updateDriverPath(
    filePath: string,
    filename: string,
    id: number
  ): Promise<CommonResponseModel> {
    console.log("upload service id---------------", id);
    try {
      let filePathUpdate;
      filePathUpdate = await this.driverRepo.update(
        { id: id },
        { profileImagePath: filePath, profileImage: filename }
      );
      if (filePathUpdate.affected > 0) {
        return new CommonResponseModel(
          true,
          11,
          "uploaded successfully",
          filePath
        );
      } else {
        return new CommonResponseModel(false, 11, "uploaded failed", filePath);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getDriverDetailsById(req: DriverId): Promise<CommonResponseModel> {
    try{
      let data = await this.driverRepo.findOne({where:{id:req.id}});
      if(data.id > 0){
        return new CommonResponseModel(true, 1, "Driver retrived", data);
      }
      else{
        return new CommonResponseModel(false, 0, "No data found", data);
      }
    }catch (error) {
      console.log(error);
    }
  }

  async getDriversByType(req: any): Promise<CommonResponseModel> {
    try{
      let data
      if(req.val === "Vendor"){
        data = await this.driverRepo.find({where:{driverType:req.val,vendorId:req.vendorId},order:{"name":'ASC'}});
      }
      else{
        data = await this.driverRepo.find({where:{driverType:req.val},order:{"name":'ASC'}});
      }

      if(data.length > 0){
        return new CommonResponseModel(true, 1, "Driver retrived", data);
      }
      else{
        return new CommonResponseModel(false, 0, "No data found", data);
      }
    }catch (error) {
      console.log(error);
    }
  }

  
}
